
<dx-data-grid id="gridContainer"
              [dataSource]="allPhasesLocal"
              keyExpr="constructionPhaseCode"
              [showBorders]="false"
              [showColumnHeaders]="true"
              [wordWrapEnabled]="true"
              [hoverStateEnabled]="true"
              (onEditorPreparing)="onEditorPreparing($event)">

  <dxo-editing mode="cell"
               [allowUpdating]="true">
  </dxo-editing>

  <dxo-sorting mode="multiple"></dxo-sorting>
  <!--  caption="Seleziona" -->
  <dxi-column dataField="selected" caption="" dataType="boolean" sortOrder="desc" [allowEditing]="true" [width]="80" [setCellValue]="resetCellHours"></dxi-column>
  <dxi-column dataField="constructionPhaseDescription" caption="Descrizione Fase" sortOrder="asc" [allowEditing]="false"></dxi-column>
  <dxi-column dataField="hoursTime" caption="Ore Effettuate" [allowEditing]="true" [width]="150" [editorOptions]="oreLavorateEditorOptions">
    <dxi-validation-rule type="custom" [validationCallback]="verificaOreNegative" message="Non sono ammesse ore negative"></dxi-validation-rule>
  </dxi-column>
  <dxo-selection mode="single"></dxo-selection>
  <dxo-paging [enabled]="false"></dxo-paging>

  <dxo-search-panel [visible]="true" [width]="240"></dxo-search-panel>
  <dxo-group-panel [visible]="false"></dxo-group-panel>


  <dxo-toolbar>
    <dxi-item name="searchPanel" location="before"></dxi-item>
  </dxo-toolbar>

</dx-data-grid>
